import React from 'react';

const NoPageFound = () => {
  return (
    <div>
      <h1>No page found</h1>
    </div>
  );
};

export default NoPageFound;
